<template>
  <h2 class="titleStepForm">Parent/Guardian information</h2>
  <div class="row">
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Parent/ Legal Guardian: Name
        </label>
        <input placeholder="Enter parent / guardian name"
          type="text"
          v-model="form.personal4.parentName"
          class="form-control"
          :disabled="radioSelected1 === 'adult'"
          :class="{
            'is-invalid': v$.form.personal4.parentName.$error,
          }"
        />
        <div
          v-for="(personal4, index) in v$.form.personal4
            .parentName.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal4.$message">{{
            personal4.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Identification No. (ID/ DP/ PP)
        </label>
        <input placeholder="Enter identification number"
          type="text"
          v-model="form.personal4.parentId"
          class="form-control"
          :disabled="radioSelected1 === 'adult'"
          :class="{
            'is-invalid': v$.form.personal4.parentId.$error,
          }"
        />
        <div
          v-for="(personal4, index) in v$.form.personal4
            .parentId.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal4.$message">{{
            personal4.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Trustee:
          <sup
            >(person authorised to act on behalf of
            minor)</sup
          >
        </label>
        <input placeholder="Enter trustee name"
          type="text"
          v-model="form.personal4.trusteeName"
          class="form-control"
          :disabled="radioSelected1 === 'adult'"
          :class="{
            'is-invalid':
              v$.form.personal4.trusteeName.$error,
          }"
        />
        <div
          v-for="(personal4, index) in v$.form.personal4
            .trusteeName.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal4.$message">{{
            personal4.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Identification No. (ID/ DP/ PP)
        </label>
        <input placeholder="Enter trustee ID number"
          type="number"
          v-model="form.personal4.trusteeId"
          class="form-control"
          :disabled="radioSelected1 === 'adult'"
          :class="{
            'is-invalid': v$.form.personal4.trusteeId.$error,
          }"
        />
        <div
          v-for="(personal4, index) in v$.form.personal4
            .trusteeId.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal4.$message">{{
            personal4.$message
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="groupFormStyle mt-4">
    <div class="">
      <h3 class="font-size-18">Statement of Declaration</h3>
      <p>FOR PERSON WHO IS NOT PARENT/ GUARDIAN/ TRUSTEE</p>
    </div>
    <div class="">
      <label
        for="declareId"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <template v-if="isEdit">
        <input
          type="checkbox"
          v-model="form.personal4.declaration"
          name="declareNme"
          :disabled="radioSelected1 === 'adult'"
          class="inputRadioCstm d-none"
          id="declareId"
          :class="{
            'is-invalid':
              v$.form.personal4.declaration.$error,
          }"
        />
        <div
          v-for="(personal4, index) in v$.form.personal4
            .declaration.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal4.$message">{{
            personal4.$message
          }}</span>
        </div>
        <span class="radioCircleIcon">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        </template>
        <template v-if="!isEdit">
        <!-- Optional validation: declaration -->
        </template>
        <div class="d-flex">
          I ,
          <template v-if="isEdit">
          <input placeholder="Enter advisor name"
            type="text"
            v-model="form.personal4.advisor"
            class="form-control mx-1 p-0 w-50"
            style="
              background-color: #fffbf8;
              border: none;
              border-bottom: 1px solid black;
              outline: none;
            "
          />
          </template>
          <template v-if="!isEdit">
          <input placeholder="Enter advisor name"
            type="text"
            v-model="form.personal4.advisor"
            class="form-control mx-1 p-2 w-50"
          />
          </template>
          declare as follows:
        </div>
      </label>
      <ol class="listOlStyle">
        <li>
          That I of my own volition opened an account in the
          name of
          <strong> {{ form.personal9.appliname }} </strong>
          who is a minor
        </li>
        <li>
          That I am neither parent nor legal guardian of this
          minor
        </li>
        <li>
          That I am aware that I will not have access to any
          funds of this minor’s account unless authorised by
          said minor’s parent or legal guardian.
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "GuardianStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["radioSelected1", "form"],
    validate: true,
    }),
  ],
};
</script>